import React from "react";
import Home from "../pages/home/Home";
import Services from "../pages/services/Services";
import About from "../pages/about/About";
// import WhyChooseUs from "../pages/whychooseus/WhyChooseUs";
import Clients from "../pages/clientlogos/ClientLogos";
import Contact from "../pages/contact/Contact";
// import Blogs from "../pages/blog/Blogs";
import Testimonials from "../pages/testimonials/Testimonials";
import HappyClients from "../pages/happyclients/HappyClients";
// import FAQ from "../pages/faq/FAQ";
import Team from "../pages/team/Team";
// import Portfolio from "../pages/portfolio/Portfolio";
import ScrollToTop from './ScrollToTop';
import Technologies from '../pages/technologies/Technologies';
import SpadaChatbot from "./ChatBoard/SpadaChatbot";

const LandingPage = () => {
  return (
    <main>
      <Home />
      <About showBreadcrumbs={false} />
      <HappyClients/>
      <Technologies/>
      <Services showBreadcrumbs={false} showExtras={false}  />
      {/* <WhyChooseUs showBreadcrumbs={false} showHeader = {true}/> */}
      <Clients/>
      {/* <Portfolio showBreadcrumbs={false} /> */}
      
      <Team showBreadcrumbs={false} showHeader = {true}/>
      {/* <FAQ showBreadcrumbs={false}/> */}
      <Testimonials showBreadcrumbs={false} />
      <Contact showBreadcrumbs={false} showHeader = {true}/>
      {/* <Blogs showBreadcrumbs={false}/> */}
      <ScrollToTop />
      <SpadaChatbot />
    </main>
  );
};

export default LandingPage;
